import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { RefObject } from 'react'
import { useSelector } from 'react-redux'

import { useAuth } from '@/hooks'
import { useProjectActions } from './useProjectActions'

export const useProjectMenu = (input: RefObject<HTMLInputElement | null>) => {
  const readOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )
  const { onClick } = useProjectActions(input)

  const avatar = useSelector(migrationProjectSelector.getProjectAvatar)

  const { authenticated } = useAuth()

  const hideMenu = readOnly || !authenticated

  return {
    onClick,
    avatar,
    hideMenu,
  }
}
